module.exports = __webpack_public_path__ + "img/pin-in-8.4f94e47f.svg";